// Central content data for the personal brand site
export const PROFILE = {
  name: "Chirag Khimani",
  handle: "@chiragkhimani",
  role: "SDET Instructor · QA Automation Architect · Corporate Trainer · Author",
  tagline:
    "Helping enterprises deliver quality at scale while mentoring engineers in modern test automation and AI-assisted QA.",
  availability: "Available for Corporate Trainings",
  photo: "/chirag-headshot.png",
  stats: [
    { label: "Years in Software Testing", value: 12, suffix: "+" },
    { label: "Engineers Trained", value: 5000, suffix: "+" },
    { label: "Published Books", value: 2, suffix: "" },
    { label: "Programs Delivered", value: 40, suffix: "+" },
  ],
  contact: {
    email: "contact@chiragkhimani.com",
    location: "Ahmedabad, India",
    linkedin: "https://www.linkedin.com/in/chiragkhimani/",
    youtube: "https://www.youtube.com/c/chiragkhimani",
    calendly: "https://calendly.com/chiragkhimani",
  },
};

export const EXPERIENCE = [
  {
    year: "2018",
    company: "HSBC",
    role: "Senior QA Automation Engineer",
    detail:
      "Architected large-scale automation for regulated banking workflows across web and API layers.",
    tags: ["Playwright", "Java", "CI/CD"],
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/phiaaghl_HSBC-Logo.webp",
  },
  {
    year: "2017",
    company: "MasterCard",
    role: "Test Automation Engineer",
    detail:
      "Built resilient E2E suites for payment systems with contract testing and shift-left QA.",
    tags: ["Selenium", "REST Assured", "TestNG"],
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/ghio25jx_MasterCard%20Logo.png",
  },
  {
    year: "2016",
    company: "Synechron",
    role: "QA Automation Engineer",
    detail:
      "Modernized legacy test estates and coached teams on framework design patterns.",
    tags: ["Cucumber", "Appium", "Jenkins"],
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/o2c6g31f_Synechron.jpeg",
  },
  {
    year: "2014",
    company: "Infostretch",
    role: "Software Engineer in Test",
    detail:
      "Delivered mobile & web automation for enterprise clients from ground up.",
    tags: ["Appium", "JUnit", "BrowserStack"],
    logo: "/logos/infostretch.png",
  },
];

export const TRAININGS = [
  {
    year: "2021",
    company: "Infosys",
    role: "Enterprise SDET Program",
    impact: ["120 Engineers Trained", "4 Week Program"],
    tags: ["Java", "Playwright", "API", "CI/CD"],
    country: "India",
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/0p75o0fw_infosys-logo.jpg",
  },
  {
    year: "2024",
    company: "UST",
    role: "Full-Stack Automation Bootcamp",
    impact: ["85 Engineers Trained", "6 Week Program"],
    tags: ["UI", "API", "Mobile", "Appium"],
    country: "India",
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/ywj058kp_UST%20Logo.webp",
  },
  {
    year: "2021",
    company: "Great Learning",
    role: "Production-Grade SDET Track",
    impact: ["200+ Engineers Trained", "8 Week Program"],
    tags: ["Java", "Selenium", "Frameworks", "CI/CD"],
    country: "India",
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/1w0iw5mn_Great_Learning_Logo.jpg",
  },
  {
    year: "2026",
    company: "Comcast",
    role: "Playwright with TypeScript",
    impact: ["60 Engineers Upskilled", "3 Week Program"],
    tags: ["Playwright", "TypeScript", "E2E", "CI/CD"],
    country: "India",
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/zl6etoms_comcast%20logo.png",
  },
  {
    year: "2023",
    company: "Devx School",
    role: "QA Career Launchpad",
    impact: ["150 Freshers Trained", "10 Week Program"],
    tags: ["Manual QA", "Selenium", "Java", "Interview Prep"],
    country: "USA",
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/sm0lzvyf_devx%20logo1.png",
  },
  {
    year: "2022",
    company: "SprintQA",
    role: "Graduate Testing Intensive",
    impact: ["90 Graduates Trained", "6 Week Program"],
    tags: ["Selenium", "API", "SQL", "Agile"],
    country: "USA",
    iconTone: "yellow",
  },
  {
    year: "2020",
    company: "DECODE Cloud Solution",
    role: "Advanced SDET Architecture",
    impact: ["45 Lateral Engineers", "5 Week Program"],
    tags: ["Framework Design", "API", "CI/CD", "Leadership"],
    country: "USA",
    logo:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/4pf58a4f_image.png",
  },
];

export const BOOKS = [
  {
    title: "Java Revision Notes",
    subtitle:
      "Specially designed for coding interview prep — purpose, syntax and examples for every topic, color-coded for quick understanding.",
    badge: "Best Seller",
    cover:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/svs45qfq_Java%20Revision%20Notes.webp",
    url: "https://www.amazon.com/Java-Revision-Notes-Color-Coded/dp/9357017798",
  },
  {
    title: "Java Coding Programs",
    subtitle:
      "300+ solved coding programs curated for interview preparation — color-coded for clarity and quick revision.",
    badge: "New Release",
    cover:
      "https://customer-assets-39nsmqrw.emergentagent.net/job_reliable-software-qa/artifacts/brpaz6yb_Java%20Coding%20Program.webp",
    url: "https://www.amazon.com/dp/936013662X",
  },
];

export const PROGRAMS = [
  {
    name: "Selenium with Java",
    detail: "From locators to enterprise-grade frameworks.",
  },
  {
    name: "Playwright with TypeScript",
    detail: "Modern, fast and reliable end-to-end testing.",
  },
  {
    name: "API Testing",
    detail: "REST Assured, Postman, contract & schema validation.",
  },
  {
    name: "Mobile Automation (Appium)",
    detail: "Android & iOS automation on real & cloud devices.",
  },
  {
    name: "Cucumber BDD",
    detail: "Living documentation with Gherkin & step defs.",
  },
  {
    name: "Java for Automation",
    detail: "Core Java, OOP & design patterns for SDETs.",
  },
  {
    name: "TestNG",
    detail: "Data-driven, parallel & grouped test execution.",
  },
  {
    name: "Jenkins & CI/CD",
    detail: "Pipelines, integrations and quality gates.",
  },
  {
    name: "Git & Version Control",
    detail: "Branching strategies, PRs and team workflows.",
  },
  {
    name: "Generative AI",
    detail: "AI-assisted testing, LLM prompts & modern QA.",
  },
  {
    name: "Agentic AI",
    detail: "Autonomous agents, MCP and next-gen automation.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Frameworks that outlive teams.",
    body: "I design test architectures that survive re-orgs, refactors and stack migrations — not clever code that only the author can maintain.",
  },
  {
    n: "02",
    title: "Engineers first, tools second.",
    body: "Great automation is 20% tooling and 80% engineering judgement. My training builds the judgement first, then the tools follow.",
  },
  {
    n: "03",
    title: "AI belongs in the pipeline.",
    body: "From self-healing locators to Agentic AI test authors — I ship pragmatic, production-safe AI patterns for real QA teams.",
  },
];
